








import Vue from 'vue'
import CoreRoot from '@corets/root'

export default Vue.extend({
    name: 'App',
    mixins: [CoreRoot]
})
